<!-- Filters Row -->
<div class="container-fluid shadow position-relative" id="filtersBox">
  <!-- Optimized Background Image -->
  <img 
  class="background-image" 
  ngSrc="/assets/images/background/Hotedršica_aerial-1920.webp"
  srcset="
    /assets/images/background/Hotedršica_aerial-768.webp 768w,
    /assets/images/background/Hotedršica_aerial-1280.webp 1280w,
    /assets/images/background/Hotedršica_aerial-1920.webp 1920w"
  sizes="(max-width: 768px) 100vw, 
         (max-width: 1280px) 100vw, 
         1920px"
  width="1920" height="1080"
  fetchpriority="high"
  priority
  alt="Aerial view of Hotedršica">


  <!-- Existing Content -->
  <div class="overlay-content flex-column justify-content-center">
    <h3 class="dancing-script text-center">
      Odkrij Hotedršico
    </h3>
    <h2 class="raleway text-center mt-3">
      najlepšo vas na Notranjskem
    </h2>
  </div>
</div>

<section id="navbar">
  <div id="orgBar" class="container-fluid">
    <img src="assets/images/organisations/gov/logo.png" alt="Logo" class="logo">
    <button id="burger" (click)="toggleMenu()">☰</button>
    <div id="menu" [ngClass]="{'show': menuOpen }">
      <div class="row justify-content-center">
        <div class="col-auto" *ngFor="let org of organisations.slice(1); let i = index">
          <a class="org-button" [routerLink]="['/organisation', org.slug]">
            {{ org.name }}
          </a>          
        </div>
      </div>
    </div>
  </div>
</section>

<div class="container">
  <h1 class="dancing-script text-center" style="color: #972f32">Novice</h1>
  <app-news-list [news]="news" [totalNewsCount]="totalItems" (loadMoreClicked)="loadMoreNews()"></app-news-list>
</div>

 <div class="events-container">
  <h1 class="dancing-script text-center align-items-center" style="color: #972f32">Prihodnji dogodki</h1>
  <app-event-list [allEvents]="allEvents" [onCalendarPage]="false"></app-event-list>
 </div>

 <div class="container pb-5">
  <h1 class="dancing-script text-center" style="color: #972f32">Galerija</h1>
  <gallery class="w-100" id="gallery" [objectFit]="'contain'" [loop]="true" [items]="images" (thumbClick)="onThumbClick($event)"></gallery>
 </div>

<div id="market" class="p-2">
  <h1 class="dancing-script text-center" style="color: #972f32">Tržnica</h1>
  <div class="container d-flex justify-content-center my-4 dancing-script">
    <a class="market-link" [routerLink]="marketRoute">
      <div class="market-card">
        <div class="market-overlay">
          <h2>Odkrij lokalno ponudbo</h2>
          <!-- Click Me Icon -->
          <img src="../../assets/images/generic/click2.png" alt="Click Me" class="click-me-icon">
        </div>
      </div>
    </a>
  </div>
  <div class="my-5">
    <app-product-list [allProducts]="allProductsShow" [onMarketPage]="true" [onHomePage]="true" [allFarms]="allFarms"></app-product-list>
  </div>
</div>


  